import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle2, X } from 'lucide-react';
export function PlanSelectPage() {
  const [annual, setAnnual] = useState(true);
  return <div className="min-h-screen bg-background py-16 px-6" data-id="element-5646">
      <div className="max-w-6xl mx-auto" data-id="element-5647">
        <div className="flex flex-col items-center mb-12" data-id="element-5648">
          <Link to="/" className="flex items-center gap-2 mb-8" data-id="element-5649">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5650">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5651"></div>
          </Link>
          <h1 className="text-4xl font-bold text-textMain mb-4 text-center" data-id="element-5652">
            Choose your plan
          </h1>
          <p className="text-textMuted text-lg text-center max-w-2xl mb-8" data-id="element-5653">
            Select the plan that fits your booking workflow. Upgrade or
            downgrade at any time.
          </p>

          <div className="flex items-center gap-3 bg-surface border border-border p-1 rounded-lg" data-id="element-5654">
            <button onClick={() => setAnnual(false)} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${!annual ? 'bg-background shadow-sm text-textMain' : 'text-textMuted hover:text-textMain'}`} data-id="element-5655">
              Monthly
            </button>
            <button onClick={() => setAnnual(true)} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${annual ? 'bg-background shadow-sm text-textMain' : 'text-textMuted hover:text-textMain'}`} data-id="element-5656">
              Annually <span className="text-primary ml-1" data-id="element-5657">Save 20%</span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-5658">
          {/* Starter */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="bg-surface border border-border rounded-2xl p-8 flex flex-col" data-id="element-5659">
            <h3 className="text-xl font-bold mb-2" data-id="element-5660">Starter</h3>
            <p className="text-sm text-textMuted mb-6 h-10" data-id="element-5661">
              For solo artists and small teams getting organized.
            </p>
            <div className="mb-8" data-id="element-5662">
              <span className="text-4xl font-bold" data-id="element-5663">$0</span>
              <span className="text-textMuted" data-id="element-5664">/mo</span>
            </div>
            <Link to="/checkout" className="w-full py-3 bg-background border border-border rounded-lg text-center font-medium hover:bg-surfaceHover transition-colors mb-8" data-id="element-5665">
              Get started
            </Link>
            <div className="space-y-4 flex-1" data-id="element-5666">
              {['1 Active Campaign', 'Basic Venue Discovery', 'Standard Inbox', 'Up to 3 Band Members'].map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-5667">
                  <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-5668" />
                  <span className="text-sm" data-id="element-5669">{feature}</span>
                </div>)}
            </div>
          </motion.div>

          {/* Pro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="bg-surface border-2 border-primary rounded-2xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(245,158,11,0.1)]" data-id="element-5670">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-background px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase" data-id="element-5671">
              Most Popular
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-5672">Pro</h3>
            <p className="text-sm text-textMuted mb-6 h-10" data-id="element-5673">
              For active artists and venues running real workflow volume.
            </p>
            <div className="mb-8" data-id="element-5674">
              <span className="text-4xl font-bold" data-id="element-5675">
                ${annual ? '39' : '49'}
              </span>
              <span className="text-textMuted" data-id="element-5676">/mo</span>
            </div>
            <Link to="/checkout" className="w-full py-3 bg-primary text-background rounded-lg text-center font-medium hover:bg-primaryHover transition-colors mb-8 shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5677">
              Start free trial
            </Link>
            <div className="space-y-4 flex-1" data-id="element-5678">
              {['Unlimited Campaigns', 'Advanced Route Planning', 'Automated Outreach', 'Contract Generation', 'Deposit Tracking', 'AI Assistant (100 prompts/mo)'].map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-5679">
                  <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-5680" />
                  <span className="text-sm" data-id="element-5681">{feature}</span>
                </div>)}
            </div>
          </motion.div>

          {/* Roster / Venue Team */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="bg-surface border border-border rounded-2xl p-8 flex flex-col" data-id="element-5682">
            <h3 className="text-xl font-bold mb-2" data-id="element-5683">Roster / Venue Team</h3>
            <p className="text-sm text-textMuted mb-6 h-10" data-id="element-5684">
              For agencies, managers, and venue teams needing approvals.
            </p>
            <div className="mb-8" data-id="element-5685">
              <span className="text-4xl font-bold" data-id="element-5686">
                ${annual ? '119' : '149'}
              </span>
              <span className="text-textMuted" data-id="element-5687">/mo</span>
            </div>
            <Link to="/contact" className="w-full py-3 bg-background border border-border rounded-lg text-center font-medium hover:bg-surfaceHover transition-colors mb-8" data-id="element-5688">
              Contact sales
            </Link>
            <div className="space-y-4 flex-1" data-id="element-5689">
              {['Everything in Pro', 'Unlimited Roster Acts', 'Multi-Room Venue Support', 'Approval Workflows', 'Custom Contract Templates', 'Unlimited AI Assistant', 'Priority Support'].map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-5690">
                  <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-5691" />
                  <span className="text-sm" data-id="element-5692">{feature}</span>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* Feature Comparison Table */}
        <div className="max-w-4xl mx-auto" data-id="element-5693">
          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-5694">
            Compare features
          </h3>
          <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-5695">
            <table className="w-full text-sm text-left" data-id="element-5696">
              <thead className="bg-background/50 border-b border-border" data-id="element-5697">
                <tr data-id="element-5698">
                  <th className="px-6 py-4 font-medium w-2/5" data-id="element-5699">Features</th>
                  <th className="px-6 py-4 font-medium text-center w-1/5" data-id="element-5700">
                    Starter
                  </th>
                  <th className="px-6 py-4 font-medium text-center w-1/5 text-primary" data-id="element-5701">
                    Pro
                  </th>
                  <th className="px-6 py-4 font-medium text-center w-1/5" data-id="element-5702">
                    Team
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-5703">
                {[{
                name: 'Active Campaigns',
                starter: '1',
                pro: 'Unlimited',
                team: 'Unlimited'
              }, {
                name: 'Venue Discovery',
                starter: 'Basic',
                pro: 'Advanced',
                team: 'Advanced'
              }, {
                name: 'Automated Outreach',
                starter: false,
                pro: true,
                team: true
              }, {
                name: 'Contract Generation',
                starter: false,
                pro: true,
                team: true
              }, {
                name: 'Deposit Tracking',
                starter: false,
                pro: true,
                team: true
              }, {
                name: 'AI Assistant',
                starter: false,
                pro: '100 / mo',
                team: 'Unlimited'
              }, {
                name: 'Approval Workflows',
                starter: false,
                pro: false,
                team: true
              }, {
                name: 'Custom Templates',
                starter: false,
                pro: false,
                team: true
              }].map((row, i) => <tr key={i} className="hover:bg-surfaceHover/50 transition-colors" data-id="element-5704">
                    <td className="px-6 py-4 font-medium text-textMuted" data-id="element-5705">
                      {row.name}
                    </td>
                    <td className="px-6 py-4 text-center" data-id="element-5706">
                      {typeof row.starter === 'boolean' ? row.starter ? <CheckCircle2 className="w-5 h-5 text-primary mx-auto" data-id="element-5707" /> : <X className="w-5 h-5 text-textMuted mx-auto opacity-50" data-id="element-5708" /> : row.starter}
                    </td>
                    <td className="px-6 py-4 text-center font-medium text-textMain" data-id="element-5709">
                      {typeof row.pro === 'boolean' ? row.pro ? <CheckCircle2 className="w-5 h-5 text-primary mx-auto" data-id="element-5710" /> : <X className="w-5 h-5 text-textMuted mx-auto opacity-50" data-id="element-5711" /> : row.pro}
                    </td>
                    <td className="px-6 py-4 text-center" data-id="element-5712">
                      {typeof row.team === 'boolean' ? row.team ? <CheckCircle2 className="w-5 h-5 text-primary mx-auto" data-id="element-5713" /> : <X className="w-5 h-5 text-textMuted mx-auto opacity-50" data-id="element-5714" /> : row.team}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}